<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :rules="elementRules"
    :label="label"
    :item-value="itemValue"
    :item-text="itemText"
    :chip-text="chipText"
    :multiple="multiple"
    :filter="tagFilter"
    :loading="loading"
    no-data-text="Ничего не найдено"
    ref="custSelect"
    >
    <template v-slot:selection="{ item, index }">
      <v-chip small v-if="index < 2">
        <span>{{ item[chipText] }}</span>
      </v-chip>
      <span v-if="index === 2" class="grey--text caption">
        (+{{ selected.length - 2 }})
      </span>
    </template>

    <template v-slot:item="data">
      <template v-if="!isObject(data.item)">
        <v-list-item v-text="data.item"></v-list-item>
      </template>
      <template v-else>
        <v-list-item-content>
          <v-list-item-title v-html="data.item[itemText]"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>

    <template v-if="multiple" v-slot:prepend-item>
      <v-list-item ripple @click="toggleAll">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title v-text="toggleAllText"> </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import { requiredRule } from "~/plugins/rules";

export default {
  props: {
    value: {
      // type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: "Выберите из списка...",
    },
    itemText: {
      type: String,
      default: "name",
    },
    chipText: {
      type: String,
      default: "name",
    },
    itemValue: {
      type: String,
      default: "id",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    selectedAll: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    elementRules: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      formRules: {
        valid: false,
        required: requiredRule,
      },
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(selected) {
        this.$emit("input", selected);
      },
    },

    icon() {
      if (this.AllItems()) return "mdi-close-box";
      if (this.someQueues()) return "mdi-plus-box";
      return "mdi-checkbox-blank-outline";
    },
    toggleAllText() {
      if (this.AllItems()) return "Отменить все";
      if (this.someQueues()) return "Выбрать все";
      return "Выбрать все";
    },
  },
  methods: {
    toggleAll() {
      this.$nextTick(() => {
        if (this.AllItems()) {
          this.selected = [];
        } else {
          this.selected = this.filteredItems().map((i) => i[this.itemValue]);
          //this.items.map((i) => i[this.itemValue]);
        }
      });
    },
    tagFilter(item, queryText) {
      const searchText = queryText.toLowerCase();
      const textOne = item[this.itemText].toLowerCase();
      let tags = null;
      let isTag = false;

      if (item.tags) {
        tags = item.tags.join(" ");
        isTag = tags.includes(searchText);
      }

      return (textOne.includes(searchText) || isTag)
    },

    filteredItems() {
      if (this.items.length > 0 && this.$refs.custSelect != undefined) return this.$refs.custSelect.filteredItems
      else return []
    },
    AllItems() {
      //return this.selected.length === this.filteredItems.length;
      return this.selected.join("") === this.filteredItems().map(i => i[this.itemValue]).join("");
      //this.items.length;
    },
    someQueues() {
      return this.selected.length > 0 && !this.AllItems();
    },

    isObject(obj) {
      return typeof obj === 'object'
    },
  },
  watch: {
    items: function (newVal, oldVal) {
      if (newVal.length !== oldVal.length) {
        if (this.selectedAll) {
          this.selected = this.items.map((i) => i[this.itemValue]);
        }
      }
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
</style>
